import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import { fetchAdminBillingAccountOrganization } from './fetchAdminBillingAccountOrganization';

export const fetchAdminBillingAccountRelations = async (call: TCall, billingAccountId: string, signal: AbortSignal) => {
  const [organization, subscriptions] = await Promise.all([
    fetchAdminBillingAccountOrganization(call, billingAccountId, signal),
    call(() => cancelOnSignal(AdminService.getAdminBillingAccountSubscriptions({ billingAccountId }), signal)),
  ]);
  return { organization, subscriptions };
};
